export var BrandCartsSortBy = /*#__PURE__*/ function(BrandCartsSortBy) {
    BrandCartsSortBy["BRAND_CARTS_SORT_BY_UNKNOWN"] = "BRAND_CARTS_SORT_BY_UNKNOWN";
    BrandCartsSortBy["UPDATED_AT"] = "UPDATED_AT";
    return BrandCartsSortBy;
}({});
